import moment from 'moment';
import config from 'config';
import chain from '@ersinfotech/chain';
import _ from 'lodash';
import request from 'helpers/superagent';
import {fetchMltDataSuccess, fetchCommentSuccess} from './actions';

const fragment = `
  ... on News {
    globalId
    mediaType
    date
    title
    content
    from
    in
    images
    words
    score
    sentiment
    isTraditional
    url
  }
  ... on Print {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    downloadUrl
    url
  }
  ... on Youtube {
    globalId
    id
    mediaType
    date
    title
    content
    from
    by
    images
    words
    comments
    likes
    hits
    score
    url
    createdAt
    updatedAt
  }
  ... on Pixnet{
    globalId
    id
    mediaType
    date
    title
    content
    from
    in
    by
    images
    words
    comments
    hits
    score
    url
    createdAt
    updatedAt
  }
  ... on Forum {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    hits
    comments
    position
    hotvalue
    words
    score
    url
  }
  ... on Weibo {
    globalId
    id
    mediaType
    date
    title
    content
    from
    by
    images
    words
    comments
    likes
    shares
    score
    url
    createdAt
    updatedAt
  }
  ... on ForumComment {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    hits
    comments
    position
    words
  }
  ... on Blog {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    words
    score
    url
  }
  ... on Video {
    globalId
    mediaType
    date
    title
    content
    from
    in
    words
    score
    url
    videoUrl
  }
  ... on Macautalk {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    words
    score
  }
  ... on Facebook {
    globalId
    mediaType
    byImageUrl
    date
    content
    from
    fromId
    by
    likes
    comments
    shares
    hotvalue
    words
    score
    picture
    source
    statusType
    message
    source
    description
    fullPicture
    images
    url
  }
  ... on Wechat {
    globalId
    mediaType
    date
    title
    content
    from
    by
    images
    hits
    likes
    words
    score
    url
  }
  ... on Twitter {
    globalId
    mediaType
    byImageUrl
    date
    content
    from
    by
    images
    likes
    shares
    words
    score
    url
    profileImageUrl
  }
  ... on Goods {
    globalId
    mediaType
    title
    content
    from
    in
    images
    averageScore
    price
    comments
    words
    score
    url
  }
  ... on Page {
    globalId
    id
    mediaType
    title
    content
    data
    from
    in
    by
    comments
    words
    score
    url
  }
`;

const commentFragment = `
  ... on ForumComment{
    content
    date
    from
    in
    by
    position
  }
  ... on FacebookComment{
    content
    by
    date
    position
  }
  ... on GoodsComment{
    content
    by
    date
    position
  }
  ... on PageComment{
    content
    date
    by
    position
  }
`;

export const fetchMltData = (data) => {
  const {access_token} = localStorage;
  return request.post(`${config.edata.baseUrl}/graphql`)
    .query({
      access_token,
    })
    .send({
      query: `
        query(
          $limit: Int
          $offset: Int
          $globalId: String!
        ) {
          mlt(
            limit: $limit
            offset: $offset
            globalId: $globalId
          ) {
            count
            data {
              ${fragment}
            }
          }
        }
      `,
      variables: data,
    })
    .endAsync()
    .get('body')
    .then(body => {
      const data = body.data.mlt;
      return fetchMltDataSuccess(data)
    })
}

export const fetchCommentData = (data) => {
  const {access_token} = localStorage;
  return request.post(`${config.edata.baseUrl}/graphql`)
    .query({
      access_token,
    })
    .send({
      query: `
        query(
          $limit: Int
          $offset: Int
          $globalId: String!
        ) {
          comment(
            limit: $limit
            offset: $offset
            globalId: $globalId
          ) {
            count
            data {
              ${commentFragment}
            }
          }
        }
      `,
      variables: data,
    })
    .endAsync()
    .get('body')
    .then(body => {
      const data = body.data.comment;
      return fetchCommentSuccess(data)
    })
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/modal/tasks.js
 **/